export default "__VITE_ASSET__C7DTbx3J__";